import React from "react";
import {
  Box,
  Flex,
  Text,
  Divider,
  Stack,
  Icon,
  Badge,
} from "@chakra-ui/react";
import {
  Phone,
  MessageCircle,
  Mail,
  User,
  Calendar,
  Clock,
  CheckCircle,
  AlertCircle,
} from "lucide-react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableAvatar from "components/Avatar/ReusableAvatar";
import { formatDate } from "utils/formatDate";

const getMethodIcon = (method) => {
  switch (method) {
    case "Call":
      return Phone;
    case "WhatsApp":
      return MessageCircle;
    case "Email":
      return Mail;
    default:
      return User;
  }
};

const ViewContactLogDrawer = ({ isOpen, onClose, log }) => {
  if (!log) return null;

  const MethodIcon = getMethodIcon(log.contact_method);

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<Text fontSize="lg">Contact Log Details</Text>}
      bodyContent={
        <Flex direction="column" p={4}>


          <Flex alignItems="center" justify="space-between">
            <Flex alignItems="center" gap={3}>
              <ReusableAvatar name={log.user_name || "User"} />

              <Box>
                <Text fontSize="xl" fontWeight="bold">
                  {log.user_name || "User"}
                </Text>

                <Text fontSize="sm" color="gray.500">
                  Contacted via {log.contact_method}
                </Text>
              </Box>
            </Flex>

            <Badge colorScheme="blue" borderRadius="12px">{log.contact_method}</Badge>
          </Flex>


          <Flex mt={3} alignItems="center" gap={4}>
            <Flex alignItems="center">
              <Icon as={Calendar} mr={1} color="gray.500" />
              <Text fontSize="sm" color="gray.500">
                {formatDate(log.contacted_at)}
              </Text>
            </Flex>

            <Flex alignItems="center">
              <Icon as={Clock} mr={1} color="gray.500" />
              <Text fontSize="sm" color="gray.500">
                Follow-up: {log.follow_up_date || "N/A"}
              </Text>
            </Flex>
          </Flex>

          <Divider my={5} />

  
          <Stack spacing={4}>

            <Box>
              <Text fontSize="xs" color="gray.400">Reason</Text>
              <Text fontWeight="500">{log.reason}</Text>
            </Box>

            <Box>
              <Text fontSize="xs" color="gray.400">Notes</Text>
              <Text>{log.notes || "No notes provided"}</Text>
            </Box>

            <Box>
              <Text fontSize="xs" color="gray.400">Outcome</Text>
              <Flex alignItems="center" gap={2}>
                <Icon as={CheckCircle} color="green.500" />
                <Text>{log.outcome || "Pending"}</Text>
              </Flex>
            </Box>

            <Box>
              <Text fontSize="xs" color="gray.400">Next Action</Text>
              <Flex alignItems="center" gap={2}>
                <Icon as={AlertCircle} color="orange.500" />
                <Text>{log.next_action || "No action set"}</Text>
              </Flex>
            </Box>

          </Stack>

          <Divider my={5} />

          <Box>
            <Text fontSize="xs" color="gray.400">Logged By</Text>
            <Text fontWeight="500">
              {log.admin_name || "Admin"}
            </Text>
          </Box>

        </Flex>
      }
    />
  );
};

export default ViewContactLogDrawer;